import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '@services/session.service';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';

export const loggedInAuthGuard: CanMatchFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!session.user()) {
    session.user.set((window as WindowWithUser).user);
  }

  if (session.user()) return true;

  void router.navigate(['/error'], { queryParamsHandling: 'preserve' });
  return false;
};
